import { defineMessages } from 'react-intl';

export const PIE_CHART_MESSAGES = defineMessages({
  downloadAsCsv: {
    id: '9JhiinIAmqWKBJae',
    defaultMessage: 'Download as CSV',
    description:
      'Text in a tooltip shown when hovering the "Download data" button in the pie chart toolbar',
  },
});
